var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-area"},[_c('div',{staticClass:"top-wrap"},[_c('div',{staticClass:"go-top-btn-wraper"},[_c('div',{class:`go-top ${_vm.visible?'active':''} go-top-button`,on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"bi bi-chevron-up"}),_c('i',{staticClass:"bi bi-chevron-up"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }